exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".EmptyPlaceholder-e879669b{height:100%;width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center}.EmptyPlaceholder-e879669b .text-1a4712d5{color:#757575;font-size:15px;line-height:19px;padding-top:15px}.EmptyPlaceholder-e879669b .border-311b729e{height:100px;width:100px;display:flex;align-items:center;justify-content:center;border:2px solid #C8E6DC;border-radius:100%}.EmptyPlaceholder-e879669b .border-311b729e>span{color:#9E9E9E}\n", ""]);

// Exports
exports.locals = {
	"EmptyPlaceholder": "EmptyPlaceholder-e879669b",
	"text": "text-1a4712d5",
	"border": "border-311b729e"
};